export const RUBRIC = [
  { id: 'physics', label: 'Physics', fail: 'No mechanism (CTE moment, interfacial peel).', pass: 'Names the mechanism and which layer or surface owns it.' },
  { id: 'evidence', label: 'Evidence', fail: 'Vibes, or one pull treated as truth.', pass: 'Uses bow (µm, ΔT, body) and peel (N/mm, which factor moved).' },
  { id: 'action', label: 'Monday', fail: '“Look into it” or change three things at once.', pass: 'One change, one measurement, one thing you will not touch.' },
  { id: 'humility', label: 'Model', fail: 'Treats the 1D beam / gripper as the package.', pass: 'Says what you still need (map, failure mode, replicates).' },
];

export const DEFENCE_NOTES = [
  {
    heading: 'What a senior is listening for',
    body: [
      'Not a novel. A call: process-mechanical vs materials vs “I do not know yet”. Then the mechanism in one sentence. Then the number from the coupon. Then the one action that would change the next lot. If you change DA, plasma, and EMC together, you learn nothing when it moves.',
    ],
  },
  {
    heading: 'A clean argument (steal this shape)',
    body: [
      '“Cool-down bow is κ from CTE mismatch; silicon is the stiff low-CTE member. Peel jumped when plasma flipped, not when we swapped A→B. Monday: plasma the pad, hold DA. Next measurement: warpage map on the real body, and peel failure-mode photos.” That is a pass even if the senior hates your voice.',
    ],
  },
];
